import React from 'react';
import { Button, Space } from 'antd';
import { ThunderboltOutlined, ShareAltOutlined } from '@ant-design/icons';

const ConnectToBidShareButtons = ({
    auction,
    slug,
    onShareClick,
    showConnectToBid = true
}) => {
    // Show "Enter Auction" whenever there's still something to enter - both
    // while the auction is live/active AND while it's scheduled and the
    // viewer just wants to go wait in the live-auction room for it to start.
    // Only hide it once the auction is completed or cancelled.
    const canEnterAuction = auction?.status !== 'completed' && auction?.status !== 'cancelled';
    const isLiveNow = auction?.status === 'live' || auction?.status === 'active';

    const handleConnectToBid = () => {
        const newWindow = window.open(
            `/live-auctions/${slug}`,
            '_blank',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1920,height=1080'
        );
        if (newWindow) {
            newWindow.focus();
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {showConnectToBid && canEnterAuction && (
                <Button
                    type="primary"
                    size="large"
                    icon={<ThunderboltOutlined />}
                    onClick={handleConnectToBid}
                    style={{
                        flex: 1,
                        height: '56px',
                        fontSize: '18px',
                        fontWeight: 600,
                        background: isLiveNow
                            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                            : 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        border: 'none',
                        boxShadow: isLiveNow
                            ? '0 4px 12px rgba(16, 185, 129, 0.3)'
                            : '0 4px 12px rgba(24, 144, 255, 0.3)',
                        transition: 'all 0.3s ease',
                        borderRadius: '8px'
                    }}
                    className={isLiveNow ? 'connect-to-bid-button live-bid-button' : 'connect-to-bid-button'}
                >
                    Enter Auction
                </Button>
            )}
            {/* <Button
                type="default"
                icon={<ShareAltOutlined />}
                onClick={onShareClick}
                style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '8px',
                    border: '1px solid #d9d9d9',
                    background: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    flexShrink: 0,
                    marginLeft: showConnectToBid && isLiveOrActive ? '0' : 'auto'
                }}
            /> */}
        </div>
    );
};

export default ConnectToBidShareButtons;

